// 疗效跟踪Icons
import { cloneDeep } from 'lodash-es'
const CurativeTypes = [
  {
    label: '不好',
    icon: require('@/assets/img/chat/curative/Discontent.png'),
    activeIcon: require('@/assets/img/chat/curative/DiscontentActive.png'),
    activeMsg: '治疗和康复需要一个过程，请您继续遵医嘱治疗，必要时建议您发起问诊和咨询。',
    status: 4
  },
  {
    label: '一般',
    icon: require('@/assets/img/chat/curative/general.png'),
    activeIcon: require('@/assets/img/chat/curative/generalActive.png'),
    activeMsg: '别灰心！请您继续遵医嘱治疗，有任何疑问可以随时线上问诊。',
    status: 3
  },
  {
    label: '良好',
    icon: require('@/assets/img/chat/curative/Satisfied.png'),
    activeIcon: require('@/assets/img/chat/curative/SatisfiedActive.png'),
    activeMsg: '真棒！继续保持，遵医嘱治疗哦，加油！',
    status: 2
  },
  {
    label: '很好',
    icon: require('@/assets/img/chat/curative/VerySatisfied.png'),
    activeIcon: require('@/assets/img/chat/curative/VerySatisfiedActive.png'),
    activeMsg: '太棒了，您的满意是我们医生的动力！期待您为医生送上一面锦旗哦～',
    status: 1
  }
]

// 医助服务评价Icons
const newCurativeTypes = cloneDeep(CurativeTypes)
const EvaluationTypes = [
  {
    label: '很不满意',
    icon: require('@/assets/img/chat/curative/LeastDiscontent.png'),
    activeIcon: require('@/assets/img/chat/curative/LeastDiscontentActive.png')
  },
  ...newCurativeTypes
]
const EvaluationLabels = ['很不满意', '不满意', '一般', '满意', '很满意']
EvaluationLabels.forEach((element, i) => {
  EvaluationTypes[i].label = element
  EvaluationTypes[i].status = i + 1
})

// 疗效反馈
const cloneCurativeTypes = cloneDeep(CurativeTypes)
const curativeEvalatueConfig = [
  {
    label: '用药中',
    status: 100,
    icon: require('@/assets/img/chat/curative/medicaling.png'),
    activeIcon: require('@/assets/img/chat/curative/medicalingActive.png'),
    activeMsg: '请您继续遵医嘱用药，用药疗程结束后及时与医生反馈药效。'
  },
  {
    label: '无效',
    status: 4,
    icon: require('@/assets/img/chat/curative/noUse.png'),
    activeIcon: require('@/assets/img/chat/curative/noUseActive.png'),
    activeMsg: '治疗和康复需要一个过程，请您继续遵医嘱治疗，必要时建议您可以发起问诊和咨询。'
  },
  { label: '有效', status: 5, activeMsg: '真棒！继续保持，遵医嘱治疗哦，加油！' },
  {
    label: '治愈',
    status: 2,
    activeMsg: '恭喜您！请继续保持良好的生活饮食习惯，期待您为医生送上一面锦旗哦～'
  }
]
const CurativeEvalatueTypes = []
cloneCurativeTypes.forEach((element, index) => {
  CurativeEvalatueTypes.push({
    ...element,
    icon: curativeEvalatueConfig[index].icon ? curativeEvalatueConfig[index].icon : element.icon,
    activeIcon: curativeEvalatueConfig[index].activeIcon
      ? curativeEvalatueConfig[index].activeIcon
      : element.activeIcon,
    label: curativeEvalatueConfig[index].label,
    status: curativeEvalatueConfig[index].status,
    activeMsg: curativeEvalatueConfig[index].activeMsg
  })
})

const GuideLablesConfig = [
  { key: 'addressInfo', label: '现居住地' },
  { key: 'currentMedicalHistory', label: '现病史' },
  { key: 'antecedentHistory', label: '既往史' },
  { key: 'allergyHistory', label: '过敏史' },
  { key: 'medicalHistory', label: '就诊情况' },
  { key: 'intentionMedicalDoctor', label: '意向医生' },
  { key: 'requiredDrugs', label: '需要开的药品' },
  { key: 'sleepQuality', label: '睡眠质量' },
  { key: 'stoolCondition', label: '大便情况' },
  // { key: 'recommendDepartment', label: '推荐就诊科室' },
  { key: 'imageList', label: '相关图片资料' }
]

const GuideLablesConfigNoImg = [
  { key: 'currentMedicalHistory', label: '现病史' },
  { key: 'antecedentHistory', label: '既往史' },
  { key: 'allergyHistory', label: '过敏史' },
  { key: 'medicalHistory', label: '就诊情况' },
  { key: 'sleepQuality', label: '睡眠质量' }
]

const AuditStatus = {
  auditing: '0', // 审核中
  pass: '1' // 审核通过
}
// 处理卡片底部提示
const getMsgTipsConfig = data => {
  const { customEvent, msgObject } = data
  const successIcon = '@/assets/img/successIcon.png'
  const auditIcon = '@/assets/img/audit.png'
  const successClassName = 'msg_tips_success'
  const warningClassName = 'msg_tips_warning'
  const isPass = msgObject?.auditStatus === AuditStatus.pass // 处方是否已经审核通过
  switch (customEvent) {
    case '29020':
      return {
        content: data?.msgObject?.underLineDesc || '',
        icon: successIcon,
        className: successClassName
      }
    case '22111':
      return {
        content: isPass ? '处方审核已通过，患者可正常购买' : '药师审核中，通过后患者即可购买',
        icon: isPass ? successIcon : auditIcon,
        className: isPass ? successClassName : warningClassName
      }
    default:
      return
  }
}

const customMessageMap = [
  {
    eventName: '咨询医生',
    type: 1,
    value: 'inquireDoctor'
  },
  {
    eventName: '查看治疗方案',
    type: 2,
    value: 'treatmentPlan'
  },
  {
    eventName: '查看订单物流',
    type: 3,
    value: 'viewOrder'
  },
  {
    eventName: '购买处方',
    type: 4,
    value: 'buyNow'
  },
  {
    eventName: '去续方',
    type: 5,
    value: 'goUniteDetails'
  },
  {
    eventName: '填写意向用药',
    type: 6,
    value: 'fillMedication'
  },
  {
    eventName: '补充诊疗记录',
    type: 7,
    value: 'supplementaryMedicalRecords'
  },
  {
    eventName: '修改复诊日期',
    type: 8,
    value: 'changeFollowupVisit'
  }
]

export {
  getMsgTipsConfig,
  CurativeTypes,
  EvaluationTypes,
  CurativeEvalatueTypes,
  GuideLablesConfig,
  GuideLablesConfigNoImg,
  AuditStatus,
  customMessageMap
}
